import React from 'react';
interface BadgeProps {
  label: string;
  variant?: 'outline' | 'filled';
  icon?: React.ReactNode;
}
export const Badge: React.FC<BadgeProps> = ({
  label,
  variant = 'outline',
  icon
}) => {
  return <div className={`inline-flex items-center rounded-full px-3 py-1 text-xs 
      ${variant === 'outline' ? 'border border-[#d4af37] text-[#d4af37]' : 'bg-[#d4af37] bg-opacity-10 text-[#d4af37]'}`} data-id="element-1532">
      {icon && <span className="mr-1" data-id="element-1533">{icon}</span>}
      {label}
    </div>;
};